<script setup>
import { computed } from 'vue'
import {useGlobalStore} from '@/store'

const globalStore = useGlobalStore()
const products = computed(() => {
  return globalStore.stepOne.products ? globalStore.stepOne.products : null
})
</script>

<template>
  <div class="form-view--step-content-registered-devices">
    <div class="form-view--step-content-registered-devices-header">
      <div></div>
      <div><span class="bold">{{ $t('stepFour.registeredDevices.serialNo') }}</span></div>
      <div><span class="bold">{{ $t('stepFour.registeredDevices.articleDescription') }}</span></div>
      <div><span class="bold">{{ $t('stepFour.registeredDevices.articleNo') }}</span></div>
    </div>
    <div class="form-view--step-content-registered-devices-device" v-for="(product, index) in products" :key="index">
      <div>
        <img :src="product.searchedProductHit.imageUrl" :alt="product.searchedProductHit.tpgName" loading="lazy"/>
      </div>
      <div>
        <span>{{product.serialNumber}}</span>
      </div>
      <div>
        <span>{{product.searchedProductHit.tpgCode}}</span>
        <span>{{product.searchedProductHit.tpgName}}</span>
      </div>
      <div>
        <span>{{product.searchedProductHit.itemNo}}</span>
      </div>
    </div>
  </div>
</template>
